import React from 'react';
import { SenderIDListPage } from './list';
import { PageContentWrapper } from 'app/layouts/wrapper/page-content';

export const SenderIDModule = () => {
  return (
    <PageContentWrapper>
      <SenderIDListPage />
    </PageContentWrapper>
  );
};
